import {useEffect, useState} from 'react';
import {setFullLoading} from '../../store/appSlice';
import {useDispatch} from 'react-redux';
import {Col, Row} from 'react-bootstrap';
import {apiGet, apiPost} from '../../apis/index';
import {useMsal} from '@azure/msal-react';
import {MdArrowBackIosNew} from 'react-icons/md';
import {useNavigate} from 'react-router-dom';
import {trackPromise} from 'react-promise-tracker';
import Swal from 'sweetalert2';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const quillModules = {
  toolbar: [
    [{header: [1, 2, 3, false]}],
    ['bold', 'italic', 'underline', 'strike'],
    [{color: []}, {background: []}],
    [{align: ''}, {align: 'center'}, {align: 'right'}, {align: 'justify'}],
    [{list: 'ordered'}, {list: 'bullet'}],
    ['link', 'image'],
    ['clean'],
  ],
};

const EmpClose = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {instance, accounts} = useMsal();
  const [isEmpClose, setIsEmpClose] = useState(false);
  const [messageTh, setMessageTh] = useState('');
  const [messageEn, setMessageEn] = useState('');
  const [htmlModeTh, setHtmlModeTh] = useState(false);
  const [htmlModeEn, setHtmlModeEn] = useState(false);
  const [bannerImage, setBannerImage] = useState('');
  const [bannerPreview, setBannerPreview] = useState('');
  const [showFullImage, setShowFullImage] = useState(false);

  // Helper function to ensure Base64 has proper prefix
  const ensureBase64Prefix = (base64String) => {
    if (!base64String) return '';
    
    // If already has data URI prefix, return as is
    if (base64String.startsWith('data:image/')) {
      return base64String;
    }
    
    // Detect image type from Base64 signature
    let mimeType = 'image/jpeg'; // default
    if (base64String.startsWith('iVBORw0KGgo')) {
      mimeType = 'image/png';
    } else if (base64String.startsWith('R0lGODlh')) {
      mimeType = 'image/gif';
    } else if (base64String.startsWith('/9j/')) {
      mimeType = 'image/jpeg';
    }
    
    return `data:${mimeType};base64,${base64String}`;
  };

  console.log('Current state:', {
    hasBannerImage: !!bannerImage,
    hasBannerPreview: !!bannerPreview,
    willShowPreview: !!(bannerPreview || bannerImage),
  });

  useEffect(() => {
    trackPromise(
        (async () => {
          try {
            dispatch(setFullLoading(true));
            const json = await apiGet({
              uri: `Maintainance/EmpCloseStatus`,
              msal: {instance, accounts},
            });
            setIsEmpClose(!!json?.empCloseMode);
            setMessageTh(json?.messageTh || '');
            setMessageEn(json?.messageEn || '');
            const formattedBanner = ensureBase64Prefix(json?.bannerImage || '');
            setBannerImage(formattedBanner);
            setBannerPreview(formattedBanner);
            console.log('Fetched banner image:', formattedBanner ? 'Image exists' : 'No image');
            dispatch(setFullLoading(false));
          } catch (error) {
            dispatch(setFullLoading(false));
            console.error('queryFn error', error);
          }
        })(),
    );
  }, [instance, accounts, dispatch]);

  const submit = async () => {
    try {
      const result = await Swal.fire({
        title: `ยืนยัน${isEmpClose ? 'เปิด' : 'ปิด'}หน้า Employee?`,
        text: isEmpClose ?
          'ระบบจะเปิดให้พนักงานเข้าถึงหน้านี้ได้' :
          'ระบบจะปิดไม่ให้พนักงานเข้าถึงหน้านี้',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      if (!result.isConfirmed) return;

      await apiPost({
        uri: `Maintainance/EmpCloseConfig`,
        msal: {instance, accounts},
        payload: {
          empCloseMode: isEmpClose ? 0 : 1,
          messageTh: messageTh,
          messageEn: messageEn,
          bannerImage: bannerImage,
          updatedBy: accounts[0]?.username || '',
        },
      });

      setIsEmpClose(!isEmpClose);

      Swal.fire({
        title: 'Updated!',
        icon: 'success',
        confirmButtonText: 'OK',
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    } catch (error) {
      console.error(error);
    }
  };

  const saveMessage = async () => {
    try {
      await apiPost({
        uri: `Maintainance/EmpCloseConfig`,
        msal: {instance, accounts},
        payload: {
          empCloseMode: isEmpClose ? 1 : 0,
          messageTh: messageTh,
          messageEn: messageEn,
          bannerImage: bannerImage,
          updatedBy: accounts[0]?.username || '',
        },
        displayCustomError: true,
      });

      Swal.fire({
        title: 'บันทึกข้อความสำเร็จ!',
        icon: 'success',
        confirmButtonText: 'OK',
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: 'บันทึกไม่สำเร็จ',
        text: error?.response?.data?.message || error?.response?.data || error?.message || 'เกิดข้อผิดพลาด',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith('image/')) {
      Swal.fire({
        title: 'ไฟล์ไม่ถูกต้อง',
        text: 'กรุณาเลือกไฟล์รูปภาพเท่านั้น',
        icon: 'error',
        confirmButtonText: 'OK',
      });
      return;
    }

    // Validate file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      Swal.fire({
        title: 'ไฟล์ใหญ่เกินไป',
        text: 'กรุณาเลือกไฟล์ที่มีขนาดไม่เกิน 5MB',
        icon: 'error',
        confirmButtonText: 'OK',
      });
      return;
    }

    // Convert to base64
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result;
      setBannerImage(base64String);
      setBannerPreview(base64String);
    };
    reader.readAsDataURL(file);
  };

  const handleRemoveBanner = () => {
    Swal.fire({
      title: 'ยืนยันการลบรูปภาพ?',
      text: 'คุณต้องการลบรูป Banner นี้หรือไม่?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'ลบ',
      cancelButtonText: 'ยกเลิก',
    }).then((result) => {
      if (result.isConfirmed) {
        setBannerImage('');
        setBannerPreview('');
      }
    });
  };

  const saveBanner = async () => {
    try {
      console.log('Saving banner:', bannerImage ? 'Image exists' : 'No image');
      
      await apiPost({
        uri: `Maintainance/EmpCloseConfig`,
        msal: {instance, accounts},
        payload: {
          empCloseMode: isEmpClose ? 1 : 0,
          messageTh: messageTh,
          messageEn: messageEn,
          bannerImage: bannerImage,
          updatedBy: accounts[0]?.username || '',
        },
        displayCustomError: true,
      });

      await Swal.fire({
        title: 'บันทึก Banner สำเร็จ!',
        icon: 'success',
        confirmButtonText: 'OK',
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      // Refresh data from API after save
      const json = await apiGet({
        uri: `Maintainance/EmpCloseStatus`,
        msal: {instance, accounts},
      });
      setIsEmpClose(!!json?.empCloseMode);
      setMessageTh(json?.messageTh || '');
      setMessageEn(json?.messageEn || '');
      const refreshedBanner = ensureBase64Prefix(json?.bannerImage || '');
      setBannerImage(refreshedBanner);
      setBannerPreview(refreshedBanner);
      console.log('Refreshed banner image:', refreshedBanner ? 'Image exists' : 'No image');
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: 'บันทึกไม่สำเร็จ',
        text: error?.response?.data?.message || error?.response?.data || error?.message || 'เกิดข้อผิดพลาด',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };

  return (
    <>
      <div className='mb-4 pointer d-flex align-items-center'>
        <div onClick={() => navigate('/back-office/settings')}>
          <MdArrowBackIosNew size={'20px'} />
          <span className='ms-2'>Settings / Employee Close</span>
        </div>
      </div>

      {/* Toggle เปิด/ปิด */}
      <div className='custom-card px-5 py-5 mb-4 mt-2 w-50' style={{margin: '0 auto'}}>
        <div className='mb-3 text-center'>
          <h5>สถานะหน้า Employee</h5>
          <p className='mt-3' style={{fontSize: '1.1rem'}}>
            สถานะปัจจุบัน:{' '}
            <span style={{
              fontWeight: 'bold',
              color: isEmpClose ? '#dc3545' : '#198754',
            }}>
              {isEmpClose ? 'ปิดอยู่' : 'เปิดอยู่'}
            </span>
          </p>
        </div>
        <Row>
          <Col xs={12}>
            <div
              className={`admin-btn d-flex align-items-center justify-content-center mt-3`}
              style={{
                cursor: 'pointer',
                backgroundColor: isEmpClose ? '#198754' : '#dc3545',
                color: '#ffffff',
                borderRadius: '8px',
                padding: '10px',
              }}
              onClick={submit}
            >
              {isEmpClose ? 'เปิดหน้า Employee' : 'ปิดหน้า Employee'}
            </div>
          </Col>
        </Row>
      </div>

      {/* ข้อความประกาศ TH / EN */}
      <div className='custom-card px-5 py-5 mb-5 w-50' style={{margin: '0 auto'}}>
        <h5 className='text-center mb-4'>ข้อความประกาศ (แสดงเมื่อปิดระบบ)</h5>

        <div className='mb-4'>
          <div className='d-flex justify-content-between align-items-center mb-2'>
            <label className='form-label fw-bold mb-0'>ข้อความภาษาไทย (TH)</label>
            <button
              type='button'
              className={`btn btn-sm ${htmlModeTh ? 'btn-dark' : 'btn-outline-secondary'}`}
              onClick={() => setHtmlModeTh(!htmlModeTh)}
            >
              {htmlModeTh ? 'Editor' : '</> HTML'}
            </button>
          </div>
          {htmlModeTh ? (
            <textarea
              className='form-control font-monospace'
              rows={10}
              value={messageTh}
              onChange={(e) => setMessageTh(e.target.value)}
              placeholder='<p>กรอก HTML ภาษาไทย...</p>'
              style={{fontSize: '0.85rem'}}
            />
          ) : (
            <ReactQuill
              theme="snow"
              modules={quillModules}
              value={messageTh}
              onChange={setMessageTh}
              placeholder='กรอกข้อความภาษาไทย...'
              style={{height: '200px', marginBottom: '50px'}}
            />
          )}
        </div>

        <div className='mb-4'>
          <div className='d-flex justify-content-between align-items-center mb-2'>
            <label className='form-label fw-bold mb-0'>ข้อความภาษาอังกฤษ (EN)</label>
            <button
              type='button'
              className={`btn btn-sm ${htmlModeEn ? 'btn-dark' : 'btn-outline-secondary'}`}
              onClick={() => setHtmlModeEn(!htmlModeEn)}
            >
              {htmlModeEn ? 'Editor' : '</> HTML'}
            </button>
          </div>
          {htmlModeEn ? (
            <textarea
              className='form-control font-monospace'
              rows={10}
              value={messageEn}
              onChange={(e) => setMessageEn(e.target.value)}
              placeholder='<p>Enter HTML in English...</p>'
              style={{fontSize: '0.85rem'}}
            />
          ) : (
            <ReactQuill
              theme="snow"
              modules={quillModules}
              value={messageEn}
              onChange={setMessageEn}
              placeholder='Enter English message...'
              style={{height: '200px', marginBottom: '50px'}}
            />
          )}
        </div>

        <Row>
          <Col xs={12}>
            <div
              className='admin-btn admin-btn-primary d-flex align-items-center justify-content-center mt-3'
              style={{cursor: 'pointer', borderRadius: '8px', padding: '10px'}}
              onClick={saveMessage}
            >
              บันทึกข้อความ
            </div>
          </Col>
        </Row>
      </div>

      {/* Banner Image Upload Section */}
      <div className='custom-card px-5 py-5 mb-5 w-50' style={{margin: '0 auto'}}>
        <h5 className='text-center mb-4'>Banner Image (แสดงเมื่อปิดระบบ)</h5>
        
        <div className='mb-4'>
          <label className='form-label fw-bold'>อัพโหลดรูปภาพ Banner</label>
          <input
            type='file'
            className='form-control'
            accept='image/*'
            onChange={handleImageUpload}
          />
          <small className='text-muted'>รองรับไฟล์: JPG, PNG, GIF (ขนาดไม่เกิน 5MB)</small>
        </div>

        {(bannerPreview || bannerImage) && (
          <div className='mb-4'>
            <label className='form-label fw-bold'>ตัวอย่างรูปภาพ</label>
            <div className='position-relative border rounded p-3' style={{backgroundColor: '#f8f9fa'}}>
              <img
                src={bannerPreview || bannerImage}
                alt='Banner Preview'
                className='w-100 rounded'
                style={{maxHeight: '400px', objectFit: 'contain', cursor: 'pointer'}}
                onClick={() => setShowFullImage(true)}
                title='คลิกเพื่อดูรูปขนาดเต็ม'
              />
              <div className='mt-3 d-flex gap-2'>
                <label
                  className='btn btn-outline-primary btn-sm'
                  style={{cursor: 'pointer'}}
                >
                  <input
                    type='file'
                    className='d-none'
                    accept='image/*'
                    onChange={handleImageUpload}
                  />
                  เปลี่ยนรูปภาพ
                </label>
                <button
                  type='button'
                  className='btn btn-outline-danger btn-sm'
                  onClick={handleRemoveBanner}
                >
                  ลบรูปภาพ
                </button>
                <button
                  type='button'
                  className='btn btn-outline-secondary btn-sm ms-auto'
                  onClick={() => setShowFullImage(true)}
                >
                  🔍 ดูขนาดเต็ม
                </button>
              </div>
            </div>
          </div>
        )}

        <Row>
          <Col xs={12}>
            <div
              className='admin-btn admin-btn-primary d-flex align-items-center justify-content-center mt-3'
              style={{cursor: 'pointer', borderRadius: '8px', padding: '10px'}}
              onClick={saveBanner}
            >
              บันทึก Banner
            </div>
          </Col>
        </Row>
      </div>

      {/* Full Image Modal */}
      {showFullImage && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
            cursor: 'pointer',
          }}
          onClick={() => setShowFullImage(false)}
        >
          <div
            style={{
              position: 'relative',
              maxWidth: '95vw',
              maxHeight: '95vh',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowFullImage(false)}
              style={{
                position: 'absolute',
                top: '-40px',
                right: '0',
                background: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '36px',
                height: '36px',
                fontSize: '20px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 10000,
              }}
              title='ปิด'
            >
              ✕
            </button>
            <img
              src={bannerPreview || bannerImage}
              alt='Banner Full Size'
              style={{
                maxWidth: '100%',
                maxHeight: '95vh',
                objectFit: 'contain',
                borderRadius: '8px',
              }}
            />
            <p style={{color: 'white', marginTop: '10px', fontSize: '14px'}}>
              คลิกที่พื้นหลังหรือปุ่ม ✕ เพื่อปิด
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default EmpClose;
